import React from "react";

import { Button, Dialog, Classes, Intent, H3, Radio, RadioGroup } from "@blueprintjs/core";

import { saveAs } from 'file-saver';
import i18n from "../../../i18n";
import i18next from "i18next";
import { Trans } from "react-i18next";
import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";
import { getExtension } from "../../../utils/mef"

export default class ExportReport extends React.Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
      generating: false,
      format: "excel"
    }
  }

  handleOpen = () => this.setState({ isOpen: true, });
  handleClose = () => this.setState({ isOpen: false, useTallContent: false,  generating: false });

  handleGenerate = () => {
    this.setState({ generating: true });
    authenticatedGetFetch(
      `/financial/exportreport?format=${this.state.format}&` + this.props.urlsearchparams,
      (data)=>{
        console.log(data.length)
        saveAs(new Blob([data]), "FinancialReport-"
          + new Date(this.props.dateRange[0]).toLocaleDateString(i18next.language)
          + "-"
          + new Date(this.props.dateRange[1]).toLocaleDateString(i18next.language)
        + `.${getExtension(this.state.format)}`);
        this.setState({ generating: false, progress: 1});
      }, undefined, undefined, 
      ()=>{
        this.setState({ generating: false });
      },
      true);    
  }

  render() {
    return (
      <div>
        <Button onClick={this.handleOpen} icon="floppy-disk" text={i18n.t("export to excel")} />
        <Dialog onClose={this.handleClose} isOpen={this.state.isOpen} style={{ transition: 'none' }}>
          <div className={Classes.DIALOG_BODY}>
            <H3><Trans>export to excel</Trans></H3>
            <div>
              <RadioGroup
                label={<Trans>export format</Trans>}
                onChange={(rad) => { this.setState({ format: rad.target.value }); }}
                selectedValue={this.state.format}
              >
                <Radio label="Excel" value="excel" />
                <Radio label="CSV" value="csv" />
                <Radio label="HTML" value="html" />
              </RadioGroup>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <Button icon='undo' intent={Intent.DANGER} onClick={this.handleClose}>
                  <Trans>cancel</Trans>
                </Button>
                <Button icon='download'
                  loading={this.state.generating}
                  onClick={this.handleGenerate}
                  text={<Trans>download</Trans>}
                />
              </div>
            </div>
          </div>
        </Dialog >
      </div>
    )
  }
}
